import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent } from 'src/app/material-module/confirm-dialog/confirm-dialog.component';
import { Template } from 'src/app/models/template';
import { TemplateService } from 'src/app/services/template.service';
import { dataTableColumnDefinition } from 'src/app/shared/resourceful-index/dataTableColumnDefinition';
import { ResourcefulIndexComponent } from 'src/app/shared/resourceful-index/resourceful-index/resourceful-index.component';
import { EditTemplateComponent } from './dialogs/edit/edit.component';

@Component({
  selector: 'templates',
  templateUrl: './templates.component.html',
  styleUrls: ['./templates.component.scss']
})
export class TemplatesComponent {


  headingText: string = 'Templates';

  relations: string[] = ['tipo_template', 'compagnia', 'studio', 'stato_incarico'];

  @ViewChild('index') index: ResourcefulIndexComponent;

  selectionMode: boolean = false;

  loading: boolean = true;

  search: any;

  columnDefinitions: dataTableColumnDefinition[] = [
    new dataTableColumnDefinition(
      {
        humanName: 'ID',
        internalName: 'id',
        type: 'link',
        href: (model) => model.id,
      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Nome',
        internalName: 'nome',

      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Descrizione',
        internalName: 'descrizione',

      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Tipo',
        internalName: 'Tipo',

        sortDisabled: true,
        displayFunction: (model) => model.tipo_template?.nome,
      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Stato automatizzato',
        internalName: 'stato_incarico',

        sortDisabled: true,
        displayFunction: (model) => model.stato_incarico?.nome,
      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Compagnia',
        internalName: 'compagnia',
        sortDisabled: true,

        displayFunction: (model) => model.compagnia?.nome,

      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Studio',
        internalName: 'studio',
        sortDisabled: true,

        displayFunction: (model) => model.studio?.nome,

      }
    ),
  ];
  constructor(public templateService: TemplateService,
    public dialog: MatDialog,
    private toast: ToastrService,
    @Optional() private dialogRef: MatDialogRef<TemplatesComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data,
    private fb: FormBuilder,) {
    if (this.data?.selectionMode) {
      this.selectionMode = true;
      this.headingText = 'Seleziona un template';
    }
  }

  async ngAfterViewInit(): Promise<void> {
    await this.updateDataSource();
    this.loading = false;
  }

  closeDialogWithSelectedModel(model) {
    this.dialogRef?.close(model);
  }

  async updateDataSource() {
    await this.index?.updateData();
  }


  deleteFunction = async (template: Template) => {
    try {
      let dialogRef = this.dialog.open(ConfirmDialogComponent, { data: { message: `Sei sicuro di voler eliminare il template ${template.nome}?` } });
      dialogRef.afterClosed().subscribe(async data => {
        if (data) {
          await this.templateService.delete(template);
          this.toast.success('Template eliminato.');
          this.updateDataSource();
        }
      });
    } catch (e) {
      console.error(e);
      this.toast.error("Eliminazione template fallita.", "Errore!");
    }
  }



  editFunction = async (template: Template) => {
    try {
      let dialogRef = this.dialog.open(EditTemplateComponent, { data: template });
      dialogRef.afterClosed().subscribe(async (data: Template) => {
        if (data) {

          Object.assign(template, data);

          await this.templateService.edit(template);

          this.toast.success('Template modificato');
          this.updateDataSource();

        }
      });

    } catch (e) {
      console.error(e);
      this.toast.error("Modifica template fallita.", "Errore!");
    }
  }


  add() {
    let addDialogRef = this.dialog.open(EditTemplateComponent, { data: this.search });
    addDialogRef.afterClosed().subscribe(data => this.handleCreation(data));
  }

  async handleCreation(template?: Template) {
    if (template) {
      try {
        await this.templateService.create(template)
        this.toast.success('Template creato!')
      }
      catch (e) {
        this.toast.error('Creazione template fallita.', 'Errore!');
      }
      finally {
        this.updateDataSource();
      }

    }
  }



}
